import request from '@/utils/request'
import { user } from './requestUrl'

export function logout(baseURL, params) {
  return request({
    baseURL,
    url: user.logout,
    method: 'get',
    params,
    loading: false,
    responseError: false
  })
}

export function queryMenu(params) {
  return request({
    url: user.queryMenu,
    method: 'post',
    params,
    loading: false
  })
}

export function queryMenuNew(baseURL, params) {
  return request({
    baseURL,
    url: user.queryMenuNew,
    method: 'get',
    params,
    loading: false
  })
}

// 获取租户信息
export function getTenantInfo(baseURL, tenantId) {
  return request({
    baseURL,
    url: user.getTenantInfo + '/' + tenantId,
    method: 'get',
    loading: false
  })
}

// 获取当前集成商logo信息
export function getCurrentAggregatorLogoInfo(baseURL) {
  return request({
    baseURL,
    url: user.getCurrentAggregatorLogoInfo,
    method: 'get'
  })
}

